module.exports = __webpack_public_path__ + "static/media/01.3f55f6e8.webp";